'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function generatePlayerId(base) {
  // Add a random suffix to the end of the base playerId, so we
  // have uniqueness.
  var suffix = (Math.random().toString(36) + '00000000000000000').slice(2, 7);

  return (base || 'DEFAULT') + '__' + suffix;
}

exports.default = generatePlayerId;